// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrowseJobCard_wrapper__P76GS","content":"BrowseJobCard_content__jv0pP","cardDetails":"BrowseJobCard_cardDetails__14xFv","title":"BrowseJobCard_title__U5QEO"};